import React, { useState } from 'react'
import adminStyles from './adminStyles.module.css'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'

const ResetEmailPassword = () => {
    const navigate=useNavigate();
    const {uuname}=useParams();
            const[password,setPassword]=useState("")

               const clearData=()=>{
        setPassword("");
    }
     const resetHandler = (e)=>{
            e.preventDefault()
           axios
           .post(`https://backendsurgylife-1.onrender.com/resetemailpassword/${uuname}`,{password})
           .then((res)=>{
            alert("Password Updated Successfully")
            navigate("/admin")
        })
           .catch((err)=>{
            alert("login failed  please check your credentials")
           })
    
        }
    
  return (
  <main className={adminStyles.adminMain}>
              
                      <section className={adminStyles.breadgum}>
                          <div className='container'>
                              <div className='row'>
                                  <div className='col-md-12'>
                                      <h1>Reset Email  Password</h1>
                                  </div>
                              </div>
                          </div>
                      </section>


                        <section className='my-5'>
                                              <div className='container'>
                                                  <div className='row '>
                                                      <div className='col-md-4 mx-auto'>
                                                        <div className={adminStyles.bx_shadow}>
                                                        <form onSubmit={resetHandler}>
                                                            
                                                   <div className='mb-3'>
                                                       <input 
                    
                                                     type='password'
                                                     name='password'
                                                      placeholder='Password' 
                                                      className='form-control'
                                                      value={password}
                                                      onChange={
                                                        (e)=>setPassword(e.target.value)
                                                      }
                                                      />
                                                   </div>
                    
                                                 
                                                     <div className='mb-3'>
                                                            <input type='button'
                                                            value='Cancel'
                                                            className='btn btn-danger me-2'
                                                            onClick={clearData}
                                                            />
                                                    <input 
                                                    type='submit' 
                                                    value='Submit'
                                                    className='btn btn-success'/>  
                    
                                                        </div>
                    
                                                        </form>
                                                        </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </section>


                      </main>
      )
}

export default ResetEmailPassword
